export const LAUNCH_USER_TYPES = {
  GUEST: 'GUE',
  REGISTERED: 'REG',
  SUBSCRIBED: 'SUB'
};
